import ES from './es';
import EN from './en';

const activity = {
    ES,
    EN
};

export default activity;
